// extracted by mini-css-extract-plugin
export var productImage = "_kb-1";
export var viewLink = "_kb-2";
export var wishlistItem = "_kb-0";